/* ANCONA V9 — Nocturne homepage interactions.
   No autoplay: visitors control the editorial chapter. Existing Ancona AI,
   Client Book, and Private Tray event systems remain the source of behavior. */
(function () {
  'use strict';

  function initHero(root) {
    if (!root || root.dataset.v9HeroReady === 'true') return;

    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-v9-hero-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-v9-hero-panel]'));
    var live = root.querySelector('[data-v9-hero-live]');
    if (!tabs.length || !panels.length) return;

    root.dataset.v9HeroReady = 'true';
    root.classList.add('is-ready');

    function activate(nextIndex, announce) {
      var nextTab = tabs[nextIndex];
      if (!nextTab) return;

      tabs.forEach(function (tab, index) {
        var selected = index === nextIndex;
        tab.classList.toggle('is-active', selected);
        tab.setAttribute('aria-selected', selected ? 'true' : 'false');
        tab.tabIndex = selected ? 0 : -1;
      });

      panels.forEach(function (panel, index) {
        var selected = index === nextIndex;
        panel.hidden = !selected;
        panel.classList.toggle('is-active', selected);
      });

      if (announce && live) {
        live.textContent = nextTab.textContent.replace(/\s+/g, ' ').trim();
      }
    }

    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () {
        activate(index, true);
      });

      tab.addEventListener('keydown', function (event) {
        var nextIndex = index;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = (index + 1) % tabs.length;
        else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = (index - 1 + tabs.length) % tabs.length;
        else if (event.key === 'Home') nextIndex = 0;
        else if (event.key === 'End') nextIndex = tabs.length - 1;
        else return;

        event.preventDefault();
        activate(nextIndex, true);
        tabs[nextIndex].focus();
      });
    });
  }

  function initAiContext(context) {
    if (!context || context.dataset.v9AiObserved === 'true' || !('IntersectionObserver' in window)) return;
    context.dataset.v9AiObserved = 'true';

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        document.body.classList.toggle('v9-ai-context-visible', entry.isIntersecting && entry.intersectionRatio > 0.12);
      });
    }, { threshold: [0, 0.12, 0.5] });

    observer.observe(context);
    context.v9AiObserver = observer;
  }

  function init(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-v9-hero]').forEach(initHero);
    root.querySelectorAll('[data-v9-ai-context]').forEach(initAiContext);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); }, { once: true });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('[data-v9-ai-context]').forEach(function (context) {
      if (context.v9AiObserver) context.v9AiObserver.disconnect();
    });
    document.body.classList.remove('v9-ai-context-visible');
  });
}());
